import { createFileRoute } from "@tanstack/react-router";
import BordeauxStrategyArticle, {
  BX_STRATEGY_DESCRIPTION,
  BX_STRATEGY_PATH,
  BX_STRATEGY_SCHEMA,
  BX_STRATEGY_TITLE,
} from "@/pages/BordeauxStrategyArticle";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/strategie-marketing-pme-bordeaux")({
  head: () => {
    const base = pageHead({ path: BX_STRATEGY_PATH, title: BX_STRATEGY_TITLE, description: BX_STRATEGY_DESCRIPTION, enPath: null });
    return {
      ...base,
      meta: [
        ...(base.meta ?? []),
        { property: "og:type", content: "article" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      scripts: BX_STRATEGY_SCHEMA.map((s) => ({ type: "application/ld+json", children: JSON.stringify(s) })),
    };
  },
  component: BordeauxStrategyArticle,
});
